export function logOrThrowError(e) {
  // the literal identifier process.env.NODE_ENV is always replaced by webpack
  // (even when the process global doesn't exist), hence disabling eslint below.
  // eslint-disable-next-line no-undef
  if(process.env.NODE_ENV === "development") {
    throw e;
  }

  // eslint-disable-next-line no-undef
  typeof Raven !== 'undefined' && Raven.captureException(e);
}


// WEBPACK FOOTER //
// ./client/utility/logging.js